import { render, staticRenderFns } from "./DashComponent2.vue?vue&type=template&id=f149a388&"
import script from "./DashComponent2.vue?vue&type=script&lang=js&"
export * from "./DashComponent2.vue?vue&type=script&lang=js&"
import style0 from "./DashComponent2.vue?vue&type=style&index=0&id=f149a388&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports